import RepositoryFactory from '../repositories/RepositoryFactory'
import { ErrorHandler } from '@/Helpers/ErrorHander'
import { convertObjectKeysToSnakeCase } from '@/Helpers/Utils'

export class MeterDetailService {
    constructor () {
        this.repository = new RepositoryFactory.get('meterDetail')
        this.meter = {
            id: null,
            serialNumber: null,
            deviceId: null,
            deviceStatus: 1,
            registered: null,
            manufacturer: null,
            tariff: null,
            owner: null,
            connectionType: null,
            connectionGroup: null,
            subConnectionType: null,
            loaded: false,
            meterType: null,
            totalRevenue: null,
            tokens: [],
            lastPaymentDate: null,
        }
    }

    fromJson (data) {
        const tokens = Array.isArray(data.tokens) ? data.tokens : []
        const lastToken = tokens.length > 0
            ? [...tokens].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0]
            : null

        this.meter = {
            id: data.id,
            serialNumber: data.serial_number,
            deviceId: data.device.id,
            deviceStatus: data.device.status ?? 1,
            registered: data.created_at,
            manufacturer: data.manufacturer,
            tariff: data.tariff,
            owner: data.device.person,
            loaded: true,
            meterType: data.meter_type,
            connectionType: data.connection_type || data.sub_connection_type?.connection_type || null,
            connectionGroup: data.connection_group,
            subConnectionType: data.sub_connection_type,
            tokens,
            totalRevenue: tokens.reduce((acc, curr) => acc + Number(curr.transaction?.amount || 0), 0),
            lastPaymentDate: lastToken ? lastToken.created_at : null
        }
    }

    async getDetail (serialNumber) {
        try {
            const { status, data, error } = await this.repository.detail(serialNumber)
            if (status !== 200) return new ErrorHandler(error, 'http', status)

            return this.fromJson(data.data)
        } catch (e) {
            const errorMessage = e.response.data.data.message
            return new ErrorHandler(errorMessage, 'http')
        }

    }

    async searchPersonForNewOwner (personService, term) {
        try {
            const { status, data } = await personService.searchPerson({ params: { term: term, paginate: 0 } })
            if (status !== 200) return new ErrorHandler(data.data.message, 'http', status)
            return data.data.map((person) => {
                return {
                    id: person.id,
                    name: person.name + ' ' + person.surname,
                    toLowerCase: () => x.name.toLowerCase(),
                    toString: () => x.name
                }
            })
        } catch (e) {
            const errorMessage = e.response.data.data.message
            return new ErrorHandler(errorMessage, 'http')
        }
    }

    async updateMeterDetails (meterData) {
        const params = convertObjectKeysToSnakeCase(meterData)
        try {
            const { data, status, error } = await this.repository.update(meterData.id, params)
            if (status !== 200 && status!== 201) return new ErrorHandler(error, 'http', status)
            return data.data
        } catch (e) {
            return new ErrorHandler(e.response.data.data.message, 'http')
        }
    }
}
